/// <amd-module name="Environments/Telemetry/EnvironmentsTelemetryService" />

import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

export interface IEnvironmentsTelemetryService extends IVssService {
    markTTI(featureArea: string, scenarioName: string, additionalProperties?: { [key: string]: any; }): void;
    onClickEvent(featureArea: string, source: string, additionalProperties?: { [key: string]: any; }): void;
    startScenario(scenarioName: string, additionalProperties?: { [key: string]: any; }): void;
    endScenario(featureArea: string, scenarioName: string, additionalProperties?: { [key: string]: any; }): void;
}


export class EnvironmentsTelemetryService extends VssService implements IEnvironmentsTelemetryService {

    public markTTI(featureArea: string, scenarioName: string, additionalProperties?: { [key: string]: any; }): void {
        const performanceService: IVssPerformanceService = this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.markTimeToInteractive(featureArea, scenarioName, undefined, additionalProperties);
    }

    public onClickEvent(featureArea: string, source: string, additionalProperties?: { [key: string]: any; }): void {
        const vssPageService: IVssPageService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = vssPageService.getData() as IPageData;
        const sessionId = pageData.sessionId;

        let properties: { [key: string]: any; } = additionalProperties || {};
        properties["sessionId"] = sessionId;
        properties["startTime"] = new Date();

        const telemetryService = this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent(featureArea, source, properties);
    }    

    public startScenario(scenarioName: string, additionalProperties?: { [key: string]: any; }): void {
        const performanceService: IVssPerformanceService = this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.startScenario(scenarioName, true, undefined, additionalProperties);
    }

    public endScenario(featureArea: string, scenarioName: string, additionalProperties?: { [key: string]: any; }): void {
        const performanceService: IVssPerformanceService = this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        performanceService.endScenario(featureArea, scenarioName, true, undefined, additionalProperties);
    }
}

Services.add("IEnvironmentsTelemetryService", { serviceFactory: EnvironmentsTelemetryService });